/**
 * Agent 首页时禁用 Copilot 选项的小组件
 * 职责：内部使用 useLocation 判断当前路径，渲染正常/禁用态的 Copilot 菜单项
 */
import React from 'react';
import { useIntl, useLocation } from 'umi';
import { Bubble } from 'tea-component';

export interface IAgentCopilotOptionProps {
  /** Copilot 模式点击回调 */
  onCopilotMode: () => void;
}

const AgentCopilotOption: React.FC<IAgentCopilotOptionProps> = ({ onCopilotMode }) => {
  const { formatMessage } = useIntl();
  const pathname = useLocation().pathname;
  const isOnAgentHome = pathname === '/agent/home';

  if (isOnAgentHome) {
    return (
      <Bubble
        content={formatMessage({ id: 'dbh_agent_entry_already_on_agent_home' })}
        placement="left"
        placementOffset={20}
        dark
      >
        <div className="dbh-agent-logo-menu-item dbh-agent-logo-menu-item--disabled">
          <span
            className="dbh-agent-logo-menu-entry-icon dbh-agent-logo-menu-entry-icon--copilot-mode"
            aria-hidden
          />
          <span className="dbh-agent-logo-menu-item-label">
            {formatMessage({ id: 'dbh_agent_entry_copilot_mode' })}
          </span>
        </div>
      </Bubble>
    );
  }

  return (
    <div
      className="dbh-agent-logo-menu-item"
      onClick={onCopilotMode}
    >
      <span
        className="dbh-agent-logo-menu-entry-icon dbh-agent-logo-menu-entry-icon--copilot-mode"
        aria-hidden
      />
      <span className="dbh-agent-logo-menu-item-label">
        {formatMessage({ id: 'dbh_agent_entry_copilot_mode' })}
      </span>
    </div>
  );
};

export default AgentCopilotOption;
